// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__ZoIKe","title":"AfterImages90_title__Lk5K8","images":"AfterImages90_images__1c4oH"};